var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from 'react';
import { Card } from 'material-ui';
var cardStyle = { margin: 20 };
export var CustomCard = function (props) { return React.createElement(Card, __assign({ style: cardStyle }, props)); };
export default CustomCard;



//////////////////
// WEBPACK FOOTER
// ./src/components/CustomCard.tsx
// module id = 75
// module chunks = 0